<!--
 * @Descripttion: 订单商品列表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-22 10:34:49
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-06 11:32:35
 -->
<template>
  <div class="cell_cont">
    <!-- 订单商品列表 -->
    <el-table :data="orderGoodsList" highlight-current-row max-height="526" border>
      <el-table-column show-overflow-tooltip label="单据编号" min-width="115px" width="140px">
        <template slot-scope="scope">
          {{ bizId }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="goodsName" label="物料名称" width="100" />
      <el-table-column show-overflow-tooltip prop="specification" label="物料规格型号" width="100" />
      <el-table-column show-overflow-tooltip prop="diCode" label="产品DI" />
      <el-table-column show-overflow-tooltip prop="goodsCode" label="物料编码" />
      <el-table-column show-overflow-tooltip prop="batchNumber" label="批号" />
      <el-table-column show-overflow-tooltip prop="packageNumber" label="出库数量" />
      <el-table-column show-overflow-tooltip prop="packLevel" label="包装层级" />
    </el-table>
  </div>
</template>
<script>
import { getOrderGoods } from '@/api/orderManage'

export default {
  name: 'OrderGoodsList',
  data() {
    return {
      // 订单商品列表数据
      orderGoodsList: [],
      bizId: null
    }
  },
  methods: {
    // 获取订单商品列表数据
    getLogisOrderGoodsLists(orderInfo) {
      const { orderId, bizId } = orderInfo
      this.bizId = bizId
      this.$emit('changeParentLoading', true)
      getOrderGoods({
        orderId,
        pageSize: 9999,
        pageNum: 1,
      }).then(res => {
        this.orderGoodsList = res.rows
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
  }
}
</script>
